<template>
  <div class="justify-content-center text-left mt-5 p-5">
    <div class="col-lg-12">
      <b-button type="submit"
                class="myButton"
                @click="$router.go(-1)"
                style="float:left">
        {{ $t('common.Back') }}
      </b-button>

      <b-button type="submit"
                class="myButton"
                @click="$router.push({ name: 'admin.templates.genecombinations.edit', params: { id:id } });"
                style="float:right">
        {{ $t('common.Edit') }}
      </b-button>
    </div>
    <div v-if="!ready"
         class="row mt-5">
      <b-spinner variant="primary"
                 type="grow"
                 label="Spinning" />
      <span>{{ $t('DataTable.Loading') }}...</span>
    </div>
    <div v-else
         class="row col-lg-12 mt-5">
      <div class="col-lg-6 dp04">
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('common.Phenotype') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              v-model="phenotype" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('common.PhenotypeEn') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              v-model="phenotypeEn" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('common.UpdatedAt') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              v-model="updatedAtFormatted" />
          </div>
        </div>
        <div class="row my-3 align-items-center">
          <div class="col-lg-3">
            <label for="createdBy">{{ $t('fields.updatedBy') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              id="updatedBy"
              class="myInput"
              :disabled="true"
              v-model="updatedBy" />
          </div>
        </div>
        <div class="row my-3 align-items-center">
          <div class="col-lg-3">
            <label for="gender">{{ $t('common.Gender') }}:</label>
          </div>
          <div class="col-lg-9">
            <GenderInput id="gender"
                         :editable="false"
                         v-model="gender.value" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('common.Category') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              v-model="category" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('common.Subcategory') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              v-model="subCategory" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('entities.GeneCombination.Singular') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-textarea
              :disabled="true"
              v-model="geneCombinationsParsed"
              class="myInput"
              no-resize
              rows="7" />
          </div>
        </div>
        <div class="row my-3 align-items-center">
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.defaultTemplateRisk') }}:</label>
          </div>
          <div class="col-lg-9">
            <TemplateRiskInput id="risk"
                               :editable="false"
                               v-model="risk" />
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="col-lg-12 mt-5">
          <div>
            <h4 class="text-center">
              {{ $t('common.Description') }}
            </h4>
            <div>
              <ckeditor v-model="description"
                        :editor="editor"
                        :disabled="true"
                        @ready="onReady"
                        :config="editorConfig" />
            </div>
          </div>
        </div>
        <div class="col-lg-12 mt-5">
          <div>
            <h4 class="text-center">
              {{ $t('common.DescriptionEn') }}
            </h4>
            <div>
              <ckeditor v-model="descriptionEn"
                        :editor="editor"
                        :disabled="true"
                        @ready="onReady"
                        :config="editorConfig" />
            </div>
          </div>
        </div>
        <div class="col-lg-12 mt-5">
          <div>
            <h4 class="text-center">
              {{ $t('EditGeneCombination.DefaultTemplate') }}
            </h4>
            <div>
              <ckeditor v-model="defaultTemplate"
                        :editor="editor"
                        :disabled="true"
                        @ready="onReady"
                        :config="editorConfig" />
            </div>
          </div>
        </div>
        <div class="col-lg-12 mt-5">
          <div>
            <h4 class="text-center">
              {{ $t('EditGeneCombination.DefaultTemplateEn') }}
            </h4>
            <div>
              <ckeditor v-model="defaultTemplateEn"
                        :editor="editor"
                        :disabled="true"
                        @ready="onReady"
                        :config="editorConfig" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import DecoupledEditor from '@ckeditor/ckeditor5-editor-decoupled/src/decouplededitor';
import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials';
import UploadAdapterPlugin from '@ckeditor/ckeditor5-adapter-ckfinder/src/uploadadapter';
import AutoformatPlugin from '@ckeditor/ckeditor5-autoformat/src/autoformat';
import HeadingPlugin from '@ckeditor/ckeditor5-heading/src/heading';
import FontFamilyPlugin from '@ckeditor/ckeditor5-font/src/fontfamily';
import FontSizePlugin from '@ckeditor/ckeditor5-font/src/fontsize';
import FontColorPlugin from '@ckeditor/ckeditor5-font/src/fontcolor';
import FontBackgroundColorPlugin from '@ckeditor/ckeditor5-font/src/fontbackgroundcolor';
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold';
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic';
import UnderlinePlugin from '@ckeditor/ckeditor5-basic-styles/src/underline';
import StrikethroughPlugin from '@ckeditor/ckeditor5-basic-styles/src/strikethrough';
import AlignmentPlugin from '@ckeditor/ckeditor5-alignment/src/alignment';
import ListPlugin from '@ckeditor/ckeditor5-list/src/list';
import IndentPlugin from '@ckeditor/ckeditor5-indent/src/indent';
import IndentBlockPlugin from '@ckeditor/ckeditor5-indent/src/indentblock';
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link';
import BlockQuotePlugin from '@ckeditor/ckeditor5-block-quote/src/blockquote';
import EasyImagePlugin from '@ckeditor/ckeditor5-easy-image/src/easyimage';
import ImagePlugin from '@ckeditor/ckeditor5-image/src/image';
import ImageCaptionPlugin from '@ckeditor/ckeditor5-image/src/imagecaption';
import ImageStylePlugin from '@ckeditor/ckeditor5-image/src/imagestyle';
import ImageToolbarPlugin from '@ckeditor/ckeditor5-image/src/imagetoolbar';
import ImageUploadPlugin from '@ckeditor/ckeditor5-image/src/imageupload';
import TablePlugin from '@ckeditor/ckeditor5-table/src/table';
import TableToolbarPlugin from '@ckeditor/ckeditor5-table/src/tabletoolbar';
import MediaEmbedPlugin from '@ckeditor/ckeditor5-media-embed/src/mediaembed';
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import HorizontalLinePlugin from '@ckeditor/ckeditor5-horizontal-line/src/horizontalline';
import GenderInput from '@components/input/GenderInput';
import TemplateRiskInput from '@components/input/TemplateRiskInput';

export default {
  name: 'GeneCombinationViewDetail',
  components: {
    GenderInput, TemplateRiskInput
  },
  data() {
    return {
      ready: false,
      editor: DecoupledEditor,
      editorConfig: {
        plugins: [
          EssentialsPlugin,
          AutoformatPlugin,
          HeadingPlugin,
          FontFamilyPlugin,
          FontSizePlugin,
          FontColorPlugin,
          FontBackgroundColorPlugin,
          BoldPlugin,
          ItalicPlugin,
          UnderlinePlugin,
          StrikethroughPlugin,
          AlignmentPlugin,
          ListPlugin,
          IndentPlugin,
          IndentBlockPlugin,
          LinkPlugin,
          BlockQuotePlugin,
          ImagePlugin,
          ImageCaptionPlugin,
          ImageStylePlugin,
          ImageToolbarPlugin,
          EasyImagePlugin,
          ImageUploadPlugin,
          TablePlugin,
          TableToolbarPlugin,
          MediaEmbedPlugin,
          ParagraphPlugin,
          UploadAdapterPlugin,
          HorizontalLinePlugin
        ],
        toolbar: [
          'heading',
          '|',
          'fontFamily',
          'fontSize',
          'fontColor',
          'fontBackgroundColor',
          '|',
          'bold',
          'italic',
          'underline',
          'strikethrough',
          '|',
          'alignment',
          '|',
          'numberedList',
          'bulletedList',
          '|',
          'outdent',
          'indent',
          '|',
          'link',
          'blockQuote',
          'imageUpload',
          'insertTable',
          'mediaEmbed',
          '|',
          'undo',
          'redo',
          '|',
          'horizontalLine'
        ],
        fontFamily: {
          supportAllValues: true
        },
        fontSize: {
          options: [
            'tiny',
            'small',
            'default',
            'big',
            'huge'
          ]
        },
        image: {
          toolbar: [
            'imageStyle:full',
            'imageStyle:side',
            '|',
            'imageTextAlternative'
          ]
        },
        table: {
          contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
        }
      }
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    ...mapState('viewGeneCombination', ['phenotype', 'phenotypeEn', 'description', 'descriptionEn', 'category', 'subCategory', 'combinationGeneCode', 'gender', 'updatedAt', 'defaultTemplate', 'defaultTemplateEn', 'updatedBy', 'risk']),
    geneCombinationsParsed() {
      return this.combinationGeneCode.join(', ');
    },
    updatedAtFormatted() {
      return this.$moment(this.updatedAt).format('DD.MM.YYYY HH:mm:ss');
    }
  },
  created() {
    this.setId(this.id);
    this.fetchGeneCombination()
      .then(() => {
        this.ready = true;
      });
  },
  methods: {
    ...mapActions({ fetchGeneCombination: 'viewGeneCombination/fetchGeneCombination' }),
    ...mapMutations({ setId: 'viewGeneCombination/setGeneCombinationId' }),
    onReady(editor) {
      // Insert the toolbar before the editable area.
      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(
          editor.ui.view.toolbar.element,
          editor.ui.getEditableElement()
        );
    },
  }
};
</script>
<style lang="scss" scoped>
</style>
